'use client'
import { usePathname } from 'lib/i18n/routing'
import ReactSubnav from '@hashicorp/react-components/src/components/subnav'

export default function Subnav() {
	const pathname = usePathname()

	return (
		<ReactSubnav
			currentPath={pathname}
			titleLink={{ text: 'Careers', url: '/careers' }}
			menuItems={[
				{ text: 'Overview', url: '/careers' },
				{
					text: 'Open Positions',
					url: '/careers/open-positions',
				},
				{
					text: 'Benefits',
					url: '/careers/benefits',
				},
				{
					text: 'How HashiCorp Works',
					url: 'https://works.hashicorp.com',
				},
				{
					text: 'Early Careers',
					url: '/careers/early-careers',
				},
			]}
		/>
	)
}
